module.exports = __webpack_public_path__ + "static/media/Untitled-7.3ac2181c.png";